// @flow
import React from 'react';

import CrumbName from './CrumbName';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__12} from '@homeaway/svg-defs';

type LinkedCrumbShape = {
    currentPage?: boolean,
    hasDivider?: boolean,
    name: string,
    onClickName: Function,
    url: string
};

const LinkedCrumb = ({
    currentPage,
    hasDivider,
    onClickName,
    name,
    url
}: LinkedCrumbShape) => {
    const ariaCurrent = currentPage ? 'page' : '';

    return (
        <li className="Breadcrumb__li">
            <a
                href={url}
                aria-current={ariaCurrent}
                className="Breadcrumb__a"
                title={name}
            >
                <CrumbName name={name} onClick={onClickName} />
            </a>
            {hasDivider && (
                <SVGIcon
                    markup={CHEVRON_RIGHT__12}
                    inlineFlex
                    className="Breadcrumb__divider"
                    aria-hidden
                />
            )}
        </li>
    );
};

export default LinkedCrumb;
